// ======================================================================
// File Name       : SuperUserAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { decamelizeKeys, camelizeKeys } from 'humps';
import _ from 'lodash';
import * as actionTypes from '../constants/actionTypes/superUser';
import { commonCallApi } from '../utils/ApiUtils';
import * as superUserRequest from './httpRequests/superuser';
import { SELECT_TARGET_DATA, MODE, RETURN_MAX_NUM_1000, SERVICE_SORT_TYPE, ASCENDING_DESCENDING_SORT } from '../constants/index';
import { serviceSearchWithoutGetEnterprise } from './ServiceAction';
import * as serviceRequests from './httpRequests/service';
export function fetchSuperUser(searchInfo = {}) {
  return async (dispatch) => {
    superUserRequest
      .postSuperUserGetList({
        selectTargetData: SELECT_TARGET_DATA.DATA,
        searchInfo,
      })
      .then(apiRes => dispatch(receiveSuperUserSearchResult(apiRes)));
  };
}

export function searchSuperUser(searchInfo = {}) {
  return (dispatch) => {
    const param = {};
    param.selectTargetData = SELECT_TARGET_DATA.DATA;
    param.searchInfo = {};
    param.searchInfo.ascendingDescendingSort = searchInfo.ascendingDescendingSort;
    param.searchInfo.returnMaxNum = searchInfo.returnMaxNum;
    searchInfo.loginId && (param.searchInfo.loginIdList = [searchInfo.loginId]);
    searchInfo.superuserName && (param.searchInfo.superuserName = searchInfo.superuserName);
    searchInfo.enterpriseCd && (param.searchInfo.enterpriseCd = searchInfo.enterpriseCd); //Step10.0.0
    searchInfo.enterpriseName && (param.searchInfo.enterpriseName = searchInfo.enterpriseName);
    (searchInfo.userSortType !== null) && (param.searchInfo.userSortType = searchInfo.userSortType);
    searchInfo.ascendingDescendingSort
    && (param.searchInfo.ascendingDescendingSort = searchInfo.ascendingDescendingSort);
    param.searchInfo.startPosition = searchInfo.startPosition !== null
    ? searchInfo.startPosition : 0;
    return commonCallApi({
      path: 'superuser/GetList',
      data: param,
      enterpriseId: 1,
    }).then((camelizeJson) => {
      dispatch(receiveSuperUserSearchResult(camelizeJson));
      dispatch(getEnterpriseList());
    });
  };
}

export function getSuperUserDetail(superuserSecernId) {
  return (dispatch) => {
    const param = {
      selectTargetData: SELECT_TARGET_DATA.DATA,
      searchInfo: {
        superuserSecernIdList: [superuserSecernId],
      },
    };
    commonCallApi({
      path: 'superuser/GetList',
      data: param,
      enterpriseId: 1,
    }).then((camelizeJson) => {
      dispatch(receiveSuperUserSearchResult(camelizeJson));
      dispatch(getEnterpriseList());
    });
  };
}

export function getEnterpriseList() {
  return (dispatch) => {
    const param = {
      selectTargetData: SELECT_TARGET_DATA.DATA,
    };
    commonCallApi({
      path: 'enterprise/GetStructure',
      data: param,
      enterpriseId: 1,
    }).then((camelizeJson) => {
      dispatch({
        type: actionTypes.SUPERUSER_RECEIVE_ENRTERPRISES,
        enterpriseList: camelizeJson.enterpriseList,
      });
    });
  };
}

export function exportSuperUserCSV(searchInfo = {}) {
  return (dispatch) => {
    const param = {
      selectTargetData: SELECT_TARGET_DATA.CSV,
      searchInfo: {
        loginIdList: searchInfo.loginId ? [searchInfo.loginId] : null,
        superuserName: searchInfo.superuserName,
        enterpriseCd: searchInfo.enterpriseCd, //Step10.0.0
        enterpriseName: searchInfo.enterpriseName,
        userSortType: searchInfo.userSortType,
        ascendingDescendingSort: searchInfo.ascendingDescendingSort,
        startPosition: searchInfo.startPosition,
        returnMaxNum: searchInfo.returnMaxNum,
      },
    };
    commonCallApi({
      path: 'superuser/GetList',
      data: param,
      enterpriseId: 1,
    }).then((camelizeJson) => {
      const link = document.createElement('a');
      link.href = camelizeJson.csvfileUrl;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };
}

export function superUserEdit(param) {
  return dispatch => commonCallApi({
    path: 'superuser/Edit',
    data: param,
    enterpriseId: 1,
  }).then((camelizeJson) => {
    dispatch({
      type: actionTypes.SUPERUSER_EDIT,
      userSecernId: camelizeJson.superuserSecernId, // Step 10.0.0
    });
  });
}

export function deleteSuperUser(superuserDetail = {}) {
  return (dispatch) => {
    const param = {
      editType: MODE.DELETE_MODE,
      superuserInfo: {
        superuserSecernId: superuserDetail.superuserSecernId,
        relationEnterpriseCd: superuserDetail.relationEnterpriseCd,
      },
    };
    commonCallApi({
      path: 'superuser/Edit',
      data: param,
      enterpriseId: 1,
    }).then((camelizeJson) => {
      // const camelizeJson = camelizeKeys(json);
    });
  };
}

function receiveSuperUserSearchResult(superUserSearchResult) {
  return {
    type: actionTypes.SUPERUSER_RECEIVE_SEARCH_RESULT,
    superuserList: superUserSearchResult.superuserList,
    recordNum: superUserSearchResult.recordNum,
  };
}

// sprint_20230418 #12 START
export function getSuperUserInfoAfterLogin(searchInfo = {}) {
  return (dispatch) => {
    const param = {};
    param.authCd = searchInfo.authCd;
    param.enterpriseId = searchInfo.enterpriseId;
    param.selectTargetData = SELECT_TARGET_DATA.DATA;
    param.smst = true;
    param.token =  searchInfo.token,
    param.searchInfo = {};
    searchInfo.userSecernId && (param.searchInfo.superuserSecernIdList = [searchInfo.userSecernId]);
    return commonCallApi({
      path: 'superuser/GetList',
      data: param,
      enterpriseId: 1,
    });
  };
}
// sprint_20230418 #12 END

// Step 10.0.0 START
export function getServiceForSuperUser(enterpriseCd, startPosition) {
  return async (dispatch, getState) => {
    const { authedUser: { enterpriseId } } = getState().authed;
    const param = {
      selectTargetData: SELECT_TARGET_DATA.DATA,
      enterpriseId,
      searchInfo: {
        enterpriseCd,
        serviceSortType: SERVICE_SORT_TYPE.SERVICE_NAME,
        ascendingDescendingSort: ASCENDING_DESCENDING_SORT.ASCENDING,
        startPosition,
        returnMaxNum: RETURN_MAX_NUM_1000,
      },
    };
    const data = await serviceRequests.getServiceList(param);
    return dispatch(allServiceRelationReceived(data));
  };
}

function allServiceRelationReceived(data) {
  return {
    type: actionTypes.SUPERUSER_RECEIVE_ALL_SERVICE,
    data,
  };
}

export function getAllServiceRelation(enterpriseCd) {
  return async (dispatch) => {
    const requests = [];
    let position = 0;
    // fetch service list
    const res = await dispatch(getServiceForSuperUser(enterpriseCd, position));
    if (res && res.data && res.data.recordNum > RETURN_MAX_NUM_1000) {
      let pager = Math.ceil(res.data.recordNum / RETURN_MAX_NUM_1000) - 1;
      while (pager > 0) {
        pager--;
        position += (RETURN_MAX_NUM_1000);

        // Update start position
        requests.push(dispatch(getServiceForSuperUser(enterpriseCd, position)));
      }
    }
    await Promise.all(requests);
  };
}

export function resetInitData() {
  return {
    type: actionTypes.SUPERUSER_RESET_INIT_DATA,
  };
}
// Step 10.0.0 END
// Step 10.1.0 START
export function sendAccountInfo(superuserSecernId) {
  return async (dispatch) => {
    const param = {
      superuserSecernId,
    };
    return commonCallApi({
      path: 'user/SendAccountInfo',
      data: param,
      enterpriseId: 1,
    });
  };
}
// Step 10.1.0 END
